/**
 * Energy tips archive: the topic chips.
 *
 * The server renders every tip with the chips hidden, so without JS the whole
 * list reads. This shows the chips and filters the rows by data-topic.
 */

export default function initTips() {
	document.querySelectorAll('[data-awdd-tip-filters]').forEach((filters) => {
		const section = filters.closest('section');
		const rows = Array.from(section ? section.querySelectorAll('[data-awdd-tip-list] > li') : []);
		const chips = Array.from(filters.querySelectorAll('[data-awdd-tip-filter]'));
		if (!rows.length || !chips.length) return;
		const shown = section.querySelector('[data-awdd-tip-shown]');

		const apply = (slug) => {
			let count = 0;
			rows.forEach((row) => {
				row.hidden = !(slug === '' || row.getAttribute('data-topic') === slug);
				if (!row.hidden) count += 1;
			});
			if (shown) shown.textContent = String(count);
		};

		chips.forEach((chip) => {
			chip.addEventListener('click', () => {
				chips.forEach((c) => c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'));
				apply(chip.getAttribute('data-awdd-tip-filter') || '');
			});
		});
		filters.hidden = false;
	});
}
